import script from "./TablaInscritos.vue?vue&type=script&setup=true&lang=ts"
export * from "./TablaInscritos.vue?vue&type=script&setup=true&lang=ts"

import "./TablaInscritos.vue?vue&type=style&index=0&id=749f453a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-749f453a"]])

export default __exports__